import React, { useContext, useRef, useState, useEffect, useCallback } from 'react'
import demoImage from "../assets/images/user.jpg"
import { Input, TextArea } from "../GitHubComponents/Inputs"
import Button from '../GitHubComponents/Button'
import "./pages.css"
import ReactMarkdown from 'react-markdown';
import { MyContext } from '..'
import { updatePublicProfile, fetchPublicProfile } from '../services'
import Alert from '@mui/material/Alert';

export default function PublicProfile(props) {
    const { backendUrl } = useContext(MyContext)
    const imageRef = useRef()
    const username = props.username
    const [formData, setFormData] = useState({
        name: "",
        description: "",
        profileImage: null
    });
    const [alert, setAlert] = useState({
        show: false,
        message: "",
        type: ""
    })
    const [profileImage, setProfileImage] = useState(demoImage);
    const handleChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'profileImage') {
            // Handle file input separately
            setFormData({ ...formData, profileImage: files[0] });
            setProfileImage(URL.createObjectURL(files[0]))
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // You can handle form submission logic here
        try {
            const data = new FormData();
            data.append('username', username);
            data.append('name', formData.name);
            data.append('description', formData.description);

            // Append the profile image file
            if (formData.profileImage) {
                data.append('profileImage', formData.profileImage);
            }
            const response = await updatePublicProfile(backendUrl, data);
            if (response.code === 200) {
                setAlert({
                    type: "success",
                    message: response.message,
                    show: true,
                });
                fetchData();
            } else {
                setAlert({
                    type: "error",
                    message: response.message,
                    show: true,
                });
            }
        } catch (error) {
            console.error('Error updating profile:', error);
        }
    };
    const fetchData = useCallback(async ()=> {
        try {
            const res = await fetchPublicProfile(backendUrl, username);
            setFormData({
                name: res.data.full_name,
                description: res.data.description,
            })
            setProfileImage(res.data.profile_image_url || demoImage)
        } catch (error) {
            console.error('Error fetching Users public profile:', error);
        }
    }, [backendUrl, username])
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    return (
        <div className='public-profile-body'>
            {alert.show && <Alert variant={"outlined"} severity={alert.type} onClose={() => { setAlert({ show: false }) }} style={{position: "absolute", right: "26px", zIndex: "2", background: "aliceblue", width: "45vw", margin: "10px auto" }}>{alert.message}</Alert>}
            <div className="left-content">
                <form onSubmit={handleSubmit}>
                    <div className="public-image">
                        <img src={profileImage} alt="" />
                        <div className="image-btn">
                            <label htmlFor="user-profile-image">
                                <Button text={"Edit"} type={"button"} style={{ backgroundColor: "white" }} onClick={() => imageRef.current.click()} />
                            </label>
                            <input ref={imageRef} type="file" id='user-profile-image' name="profileImage" onChange={handleChange} style={{ display: "none" }} />
                        </div>
                    </div>
                    <div className="profile-meta">
                        <Input type={"text"} name={"name"} lable={"Name"} style={{ width: "296px" }} value={formData.name} onChange={handleChange} />
                        <TextArea name={"description"} lable={"Description"} style={{ width: "296px" }} value={formData.description} onChange={handleChange} />
                    </div>
                    <div className="form-btn d-flex">
                        <Button text={"Update"} type={"submit"} style={{ color: "white", backgroundColor: "#1f883d", marginRight: "10px" }} />
                        <Button text={"Cancel"} type={"button"} onClick={()=>{fetchData()}}/>
                    </div>
                </form>
            </div>
            <div className="right-content">
                <div className="description">
                    <ReactMarkdown>{formData.description}</ReactMarkdown>
                </div>
            </div>
        </div>
    )
}